import React from "react";
export function TableColGroup(_a) {
    var columns = _a.columns;
    return (React.createElement("colgroup", null, columns.map(function (_a) {
        var key = _a.key, width = _a.width;
        return (React.createElement("col", { key: key, style: {
                width: typeof width === "undefined" ? "auto" : width,
            } }));
    })));
}
TableColGroup.displayName = "TableColGroup";
//# sourceMappingURL=TableColGroup.js.map